<template>
    <div class="check-list-results">
        <apexcharts
            v-if="hasAnswers()"
            type="pie"
            width="100%"
            height="auto"
            :options="options"
            :series="series">
        </apexcharts>

        <div
            class="not-found with-header result-list"
            v-else>
            <div class="alert-notice">{{$t('group.assignment_not_finished')}}</div>
        </div>
    </div>
</template>

<script>
import apexcharts from 'vue-apexcharts';

export default {
    name: 'design-2021-group-results-check-list-component',
    components: { apexcharts },
    props: {
        partIn: {
            type: Object,
        },
    },
    data() {
        return {
            options: {
                chart: {
                    type: 'pie',
                },
                labels: this.partIn.list_items.map((option) => option.value),
                dataLabels: {
                    enabled: true,
                    formatter: (val, opts) => {
                        const index = opts.seriesIndex;
                        return opts.w.config.series[index];
                    },
                },
                responsive: [
                    {
                        breakpoint: 1200,
                        options: {
                            legend: {
                                position: 'bottom',
                            },
                        },
                    },
                    {
                        breakpoint: 1400,
                        options: {
                            legend: {
                                position: 'right',
                            },
                        },
                    },
                ],
                tooltip: {
                    enabled: true,
                    custom: this.handleToolTip,
                },
            },
            series: this.partIn.list_items.map((option) => option.check_count),
        };
    },

    methods: {
        handleToolTip({ seriesIndex, series, dataPointIndex, w }) {
            const label = w.config.labels[seriesIndex];
            const value = series[seriesIndex];
            const users = this.getStudents(label);

            return `<div class="standard-list-tooltip choices-stats-tooltip">
                    <div class="header">${label}</div>
                    <div class="content">
                        <span class="label">`+this.$t('group.results_number_students')+`</span>
                        <span class="value">${value}</span>
                        <div class="students">
                        ${users}
                        </div>
                    </div>
                </div>
        `;
        },

        getStudents(label) {
            const users = [];
            const option = this.partIn.list_items.find((option) => option.value === label);

            option.list_checks.forEach((listItem) => {
                if (listItem.answer.assignment_answerable.users.length > 0) {
                    users.push(
                        `<span class="student">${listItem.answer.assignment_answerable.users[0].full_name}</span>`,
                    );
                }
            });

            return users;
        },

        hasAnswers() {
            let hasAnswers = false;

            for (let i = 0; i < this.partIn.list_items.length; i++) {
                if (this.partIn.list_items[i].list_checks.length > 0) {
                    hasAnswers = true;
                }
            }

            return hasAnswers;
        },
    },
};
</script>

<style scoped lang="scss">
.not-found {
    align-items: flex-start;

    .alert-notice {
        font-size: $base-font-size;
        color: $text-muted-color;
    }
}
</style>
